import { View } from 'foundations-components/components/View';
import { Text } from 'foundations-components/components/Text';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { LoadingSkeleton } from 'deal-intel-utils/components/LoadingSkeleton';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export const MeetingFollowUpPopoverContentLoadingState = () => {
  return /*#__PURE__*/_jsxs(View, {
    "data-test-id": "meeting-follow-up-popover-content-loading-state",
    padding: "500",
    inlineSize: "288px",
    children: [/*#__PURE__*/_jsx(Text, {
      typography: "heading-100",
      marginBlockEnd: "200",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "meetingFollowUp.popoverContent.title"
      })
    }), /*#__PURE__*/_jsx(LoadingSkeleton, {
      height: "16px",
      width: "100%",
      marginBlockEnd: "100"
    }), /*#__PURE__*/_jsx(LoadingSkeleton, {
      height: "16px",
      width: "100%",
      marginBlockEnd: "200"
    }), /*#__PURE__*/_jsx(LoadingSkeleton, {
      height: "16px",
      width: "100%"
    })]
  });
};